import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./components/home/Home";
import "./App.css";
import NavBar from "./components/home/NavBar";
import AboutUs from "./components/AboutUs";
import ContactUs from "./components/ContactUs";
import Careers from "./components/Careers";
import Aos from "aos";
import "aos/dist/aos.css";
import Footer from "./components/Footer";
import Infrastructure from "./components/Infrastructure";
import History from "./components/History";
import ScrollToTop from "./components/ScrollToTop";
import ProductList from "./components/ProductList";
import Testimonials from "./components/Testimonials";
import NewsCopy from "./components/News";
import MyContext from "./MyContext";
import ProductDetails from "./components/ProductDetails";
import { getProduct } from "./services/productService";
import { getGallery } from "./services/galleryServices";

function App() {
  const [productObj, setProductObj] = useState([]);
  const [gallery, setGallery] = useState([]);

  const fetchData = async () => {
    try {
      // 1. Fetch and Sanitize Product Data
      const dataArray = await getProduct();
      const tempProducts = [];
      dataArray.forEach((item) => {
        if (item.data) {
          tempProducts.push(item.data);
        }
      });
      setProductObj(tempProducts);

      // 2. Fetch and Sanitize Gallery Data
      const galleryArray = await getGallery();
      setGallery(galleryArray);

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    Aos.init({
      duration: 1000,
      offset: 0,
    });
    fetchData();
  }, []);

  return (
    <div>
      <MyContext.Provider value={{ productObj: productObj, setProductObj: setProductObj, gallery: gallery }}>
        <Router>
          <ScrollToTop />
          <div>
            {/* Header always renders cleanly on all pages */}
            <NavBar />

            <Switch>
              <Route exact path="/" component={Home} />
              <Route path="/contact" component={ContactUs} />
              <Route path="/about" component={AboutUs} />
              <Route path="/careers" component={Careers} />
              <Route path="/carrier" component={Careers} />
              <Route path="/news&media" component={NewsCopy} />
              <Route exact path="/products" component={ProductList} />
              <Route path="/infrastructure" component={Infrastructure} />
              <Route path="/building" component={Infrastructure} />
              <Route path="/history" component={History} />
              <Route path="/product/:id" component={ProductDetails} />
              <Route path="/testimonials" component={Testimonials} />
            </Switch>

            {/* Global Slate Footer always renders safely without duplication issues */}
            <Footer />
          </div>
        </Router>
      </MyContext.Provider>
    </div>
  );
}

export default App;